<template>
	<div class="casus">
		<div class="card_1" :style="{backgroundImage:'url(' + img.bgCard_1 + ')'}">
			<div class="title">
				<h1>客户成功案例</h1>
				<div class="line"></div>
				<p>针对各行业业务特性，打造个性化行业解决方案，为客户提供一站式的产品与服务。</p>
				<p>让客户可以轻松实现物联网产品的开发和管理，让产品互联互通。</p>
			</div>
			<div class="pic_box">
				<img class="phone_border" src="../assets/img/casus/pone.png" />
				<template v-for="(item,i) in aPointImgList">
					<transition name="fade" mode="out-in">
						<img class="phone_content" v-if="iPointIndex==(i+1)" :src="aPointImgList[i]" />
					</transition>
				</template>
			</div>			
			<div class="point-list">
				<template v-for="i in aPointImgList.length">
					<div class="point" :class="{active:iPointIndex==i}" @click="fnPointClick(i)"></div>
				</template>
			</div>
		</div>
		<div class="card_2" :style="{backgroundImage:'url(' + img.bgCard_2 + ')'}">
			<h1>智能软件制定开发</h1>
			<div class="line"></div>
			<p>针对各行业业务特性，打造个性化行业解决方案，为客户提供一站式的产品与服务。</p>
			<p>让客户可以轻松实现物联网产品的开发和管理，让产品互联互通。</p>
			<img src="../assets/img/casus/pic_version.png" />
		</div>
		<div class="card_3">
			<h1>案例展示</h1>
			<div class="line"></div>
			<el-row>
				<template v-for="item in aList">
					<el-col :span="4">
						<div class="item">
							<img :src="item.img" />
							<p>{{item.name}}</p>
						</div>
					</el-col>
				</template>
			</el-row>
		</div>
		<div class="card_4">
			<h1>受益用户</h1>
			<div class="line"></div>
			<el-row :gutter="20">
				<template v-for="item in aCard">
					<el-col :span="6">
						<div class="item">
							<img :src="item.img" />
							<p>{{item.name}}</p>
						</div>
						<div class="desc">{{item.desc}}</div>
					</el-col>
				</template>
			</el-row>
		</div>
		<foot></foot>
	</div>
</template>

<script>
	import foot from '@/modules/home/page_6.vue'
	export default {
		name: 'casus',
		data() {
			return {
				img: {
					bgCard_1: require("@/assets/img/casus/pic_bg.jpg"),
					bgCard_2: require("@/assets/img/casus/pic_development.png")
				},
				t1:null,
				"iPointIndex": 1,
				"aPointImgList": [
					require("@/assets/img/casus/smartlock_banner_1.png"),
					require("@/assets/img/casus/smartlock_banner_2.png"),
					require("@/assets/img/casus/smartlock_banner_3.png")
				],
				aList: [{
						name: "太阳能充电桩",
						img: require("@/assets/img/casus/list_1.png")
					},
					{
						name: "市电路灯",
						img: require("@/assets/img/casus/list_2.png")
					},
					{
						name: "室内智能灯",
						img: require("@/assets/img/casus/list_3.png")
					},
					{
						name: "太阳能路灯",
						img: require("@/assets/img/casus/list_4.png")
					},
					{
						name: "智能插座",
						img: require("@/assets/img/casus/list_5.png")
					},
					{
						name: "净水器",
						img: require("@/assets/img/casus/list_6.png")
					},
					{
						name: "空气净化器",
						img: require("@/assets/img/casus/list_7.png")
					},
					{
						name: "空调",
						img: require("@/assets/img/casus/list_8.png")
					},
					{
						name: "心电测量仪",
						img: require("@/assets/img/casus/list_9.png")
					},
					{
						name: "智能门禁",
						img: require("@/assets/img/casus/list_10.png")
					},
					{
						name: "按摩披肩",
						img: require("@/assets/img/casus/list_11.png")
					},
					{
						name: "智能SPA沐浴",
						img: require("@/assets/img/casus/list_12.png")
					},
				],
				aCard: [{
						name: "建霖工业",
						desc: "利用了Qiot公版定制开发，降低了成本。",
						img: require("@/assets/img/casus/logo_1.png")
					},
					{
						name: "冠宇科技",
						desc: "基于Qiot云平台定制开发，使系统的性能提升了200%",
						img: require("@/assets/img/casus/logo_2.png")
					},
					{
						name: "曙创科技",
						desc: "基于Qiot云平台定制开发，降低了成本。",
						img: require("@/assets/img/casus/logo_3.png")
					},
					{
						name: "可锐卓",
						desc: "利用Qiot快速完成产品的更新和功能扩展，节省时间。",
						img: require("@/assets/img/casus/logo_4.png")
					},
				]
			}
		},
		//计算数据
		computed: {},
		//参数数据
		props: {},
		//方法
		methods: {
			fnInterval() {
				if(this.t1 != null){
					window.clearInterval(this.t1);
				}
				var _this = this;
				this.t1 = setInterval(function() {
					_this.iPointIndex = _this.iPointIndex + 1 > _this.aPointImgList.length ? 1 : _this.iPointIndex + 1;
				}, 3000);
			},
			fnPointClick(index){
				this.iPointIndex = index;
				this.fnInterval();
			},
		},
		//组件
		components: {
			foot
		},
		//生命周期-创建
		created() {},
		//生命周期-准备就绪
		mounted() {
			this.fnInterval();
		},
		//监控变量
		watch: {}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	@import url("../assets/common.less");
	
	.fade-enter-active, .fade-leave-active {
	  transition: opacity 1s
	}
	.fade-enter, .fade-leave-active {
	  opacity: 0
	}
	.casus {
		.text() {
			h1 {
				font-size: 48px;
				font-weight: 500;
				text-align: center;
			}
			&>.line {
				width: 40px;
				height: 6px;
				background-color: @theme-color;
				margin: 18px auto 56px;
				text-align: center;
			}
			p {
				font-size: 20px;
				text-align: center;
			}
		}
		.card_1 {
			background-position: center top;
			background-size: 100% 86%;
			background-repeat: no-repeat;
			height: 1316px;
			position: relative;
			.title {
				padding-top: calc(~"140px");
				color: #FFF;
				.text();
			}
			.pic_box {
				position: relative;
				width: 35%;
				margin: 336px auto 0;
				.phone_border {
					width: 80%;
					padding: 0 10%;
					position: absolute;
					z-index: 10;
				}
				.phone_content {
					width: 80%;
					padding: 0 10%;
					position: absolute;
					z-index: 9;
				}
				.el-carousel__container {
					height: 500px;
				}
			}
			.point-list{    
				overflow: hidden;
				width: 100px;
				margin: 0 auto;
				bottom: 50px;
				position: absolute;
				left: 0;
				right: 0;
				z-index: 999;
				.point{
					width: 6px;
					height: 6px;
					background: #0ae;
					border-radius: 50%;
					margin: 8px 10px;
					float: left;
					opacity: 0.5;
					cursor: pointer;
					.transition(all,0.3s);
					&.active{
						opacity: 1;
						width: 10px;
						height: 10px;
						margin: 6px 10px;
					}
				}
			}
		}
		.card_2 {
			padding-top: 30px;
			height: 400px;
			background-color: #f6f6f6;
			background-size: 50% 100%;
			background-position: center center;
			background-repeat: no-repeat;
			text-align: center;
			.text();
			img {
				margin-top: 40px;
			}
		}
		.card_3 {
			background-color: #2d3238;
			padding-top: 30px;
			height: 1001px;
			color: #FFF;
			.text();
			.el-row {
				width: 1080px;
				margin: 0 auto;
				.item {
					text-align: center;
					padding: 20px 0;
					p {
						padding-top: 10px;
					}
				}
			}
		}
		.card_4 {
			padding-top: 30px;
			.text();
			.el-row {
				width: 1080px;
				margin: 0 auto !important;
				.item {
					border: 1px solid #8391A5;
					height: 180px;
					position: relative;
					img {
						position: absolute;
						left: 0;
						right: 0;
						top: 15%;
						margin: 0 auto;
						width: 50%;
					}
					P {
						position: absolute;
						left: 0;
						right: 0;
						bottom: 15%;
					}
				}
				.desc {
					width: 90%;
					margin: 20px auto;
					text-indent: 2em;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// Casus.vue?60b85502